// Pure evaluation of the rooms-without-images notification. Kept free of the
// redux store / api imports so it can be unit tested in isolation.

/**
 * Counts the room types that have no image assigned in their gallery.
 *
 * Gallery entries for rooms that no longer exist are ignored, since only the
 * given rooms are counted.
 *
 * @param {Array<{ id: string }>} rooms the property's rooms (may be null)
 * @param {Object} roomGalleries galleries.rooms, keyed by room id (may be undefined)
 * @returns {{ missing: number, total: number }}
 */
export const countRoomsWithoutImages = (rooms, roomGalleries) => {
  const total = rooms?.length ?? 0
  const missing = (rooms ?? []).filter(room => !(roomGalleries?.[room.id]?.order?.length > 0)).length
  return { missing, total }
}
